import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalContext } from 'utils/context';
import './deleteModal.style.scss';

export const DeleteModal = ({ headerModal }) => {
  const { t } = useTranslation();

  return (
    <ModalContext.Consumer>
      {(context) => {
        if (context.showModal) {
          return (
            <div className="modal_delete">
              <div className="content">
                <div>
                  <p>{headerModal}</p>
                </div>
                <div>
                  <button onClick={context.toggleModal}>{t('common.cancel')}</button>
                  <button
                    onClick={() => {
                      context.setConfirmDeletion(true);
                      context.toggleModal();
                    }}
                  >
                    {t('common.confirm')}
                  </button>
                </div>
              </div>
            </div>
          );
        }
        return null;
      }}
    </ModalContext.Consumer>
  );
};
